var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionaldark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 932,
    viewBox: "0 0 1001 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_885_1063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1001,
    height: 932
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000.19 0H0.189941V931.66H1000.19V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_885_1063)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.19 0.47998H0.189941V931.65H1000.19V0.47998Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M894.19 604.69V580.23L869.25 585.13L870.61 604.69H894.19Z",
    fill: "#D7DCE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M894.19 604.69L476.85 363.73L-342.08 812.09V836.55L-62.3601 998.05L-123.54 1008.92V1033.38L473.36 1378.01L534.54 1342.68L661.74 1416.12H814.07L1480.66 1031.26V943.31L1288.39 832.3C1267.91 844.13 1234.7 844.13 1214.22 832.3C1193.74 820.48 1193.74 801.3 1214.22 789.48L968.35 647.53C947.87 659.36 914.66 659.36 894.18 647.53C873.7 635.7 873.7 616.53 894.18 604.71L894.19 604.69Z",
    fill: "white",
    stroke: "#0F1320",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M894.19 580.23L476.85 339.27L-342.08 812.09L-62.3601 973.59L-123.54 1008.92L473.36 1353.55L534.54 1318.22L661.74 1391.66H814.07L1480.66 1006.8V918.85L1288.39 807.84C1267.91 819.67 1234.7 819.67 1214.22 807.84C1193.74 796.01 1193.74 776.84 1214.22 765.02L968.35 623.07C947.87 634.9 914.66 634.9 894.18 623.07C873.7 611.24 873.7 592.07 894.18 580.25L894.19 580.23Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M778.29 1228.65L-142.64 696.94L-96.7501 670.44L824.18 1202.16L923.92 1202.18L1287.94 992.01L1333.83 1018.5L969.81 1228.68L778.29 1228.65Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M592.67 506.95V507.17C592.67 508.53 591.99 509.88 590.63 511.03C590.21 511.39 589.73 511.73 589.18 512.05C551.58 534.06 470.81 580.38 468.2 581.88C463.81 584.42 456.75 584.6 452.04 582.25C428.81 570.73 407.12 558.21 387.18 544.8C385.26 543.51 384.32 541.92 384.32 540.34V524.19C384.32 525.77 385.27 527.37 387.18 528.65C407.12 542.07 428.82 554.58 452.04 566.1C456.75 568.45 463.81 568.26 468.2 565.73C470.8 564.23 551.57 517.91 589.18 495.9C589.73 495.58 590.2 495.24 590.63 494.88C591.91 493.8 592.59 492.53 592.67 491.27V506.94V506.95Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M592.67 490.7V491.28C592.58 492.54 591.91 493.8 590.63 494.89C590.21 495.25 589.73 495.59 589.18 495.91C551.58 517.92 513.72 539.47 475.99 561.25L395.59 514.83L508.78 449.49C509.32 449.17 509.92 448.88 510.55 448.64C514.91 446.97 520.83 447.07 524.94 449.12C548.18 460.64 569.86 473.16 589.8 486.57C591.59 487.78 592.52 489.24 592.66 490.7H592.67Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M476.92 561.79C474.33 563.29 471.73 564.78 469.13 566.28C464.74 568.82 457.68 569 452.97 566.65C429.74 555.13 405.98 541.61 386.04 528.19C384.13 526.91 384.33 525.78 384.33 524.2C384.33 524.15 384.33 524.1 384.33 524.05C384.36 522.33 384.42 520.16 386.67 518.87L394.46 514.36L476.93 561.79H476.92Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M592.669 490.7V506.95",
    stroke: "#373A3A",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.39 500.18V487.26H490.77",
    stroke: "#FBB93E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M517.72 502.83V515.73H495.36",
    stroke: "#FBB93E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M513.24 495.07L472.61 507.8",
    stroke: "#FBB93E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.21 694.22C313.58 692.71 313.91 690.07 316.92 688.33L408.21 635.63C411.24 633.9 415.77 633.71 418.39 635.22L766.48 836.19C769.1 837.69 768.76 840.32 765.75 842.06L674.46 894.76C671.45 896.5 666.9 896.68 664.28 895.19L316.2 694.22H316.21ZM364.74 685.8L349.06 694.84L364.72 703.88L380.38 694.84L364.73 685.8H364.74ZM391.73 670.23L376.08 679.25L391.73 688.29L407.38 679.25L391.73 670.23ZM392.3 701.71L376.64 710.75L392.29 719.79L407.95 710.75L392.3 701.71ZM418.73 654.64L403.07 663.68L418.72 672.72L434.38 663.66L418.73 654.64ZM419.28 686.14L403.63 695.16L419.28 704.2L434.93 695.16L419.28 686.14ZM419.85 717.63L404.19 726.67L419.84 735.71L435.5 726.67L419.85 717.63ZM446.28 670.55L430.62 679.59L446.27 688.61L461.95 679.57L446.29 670.55H446.28ZM446.74 733.15L431.08 742.19L446.74 751.25L462.4 742.19L446.74 733.15ZM446.83 702.05L431.18 711.07L446.83 720.11L462.49 711.07L446.83 702.05ZM473.66 748.69L457.98 757.73L554.27 813.32L569.93 804.28L473.66 748.69ZM473.73 717.57L458.08 726.59L473.74 735.65L489.39 726.61L473.73 717.57ZM473.85 686.46L458.17 695.5L473.83 704.52L489.49 695.48L473.84 686.46H473.85ZM500.64 733.11L484.99 742.13L500.64 751.17L516.29 742.13L500.64 733.11ZM500.73 701.98L485.07 711.02L500.73 720.06L516.41 711.02L500.73 701.98ZM527.52 748.63L511.87 757.65L527.55 766.71L543.2 757.67L527.52 748.63ZM527.64 717.52L511.98 726.56L527.63 735.58L543.29 726.54L527.64 717.52ZM554.37 764.12L538.71 773.16L554.39 782.2L570.04 773.18L554.38 764.12H554.37ZM554.53 733.04L538.85 742.08L554.53 751.12L570.19 742.08L554.53 733.04ZM581.18 810.77L565.52 819.81L581.18 828.85L596.84 819.81L581.18 810.77ZM581.27 779.66L565.62 788.7L581.27 797.72L596.92 788.7L581.27 779.66ZM581.38 748.52L565.72 757.58L581.38 766.62L597.04 757.58L581.38 748.52ZM608.09 826.31L592.41 835.35L608.06 844.37L623.74 835.33L608.09 826.31ZM608.16 795.18L592.51 804.22L608.17 813.26L623.82 804.24L608.16 795.18ZM608.29 764.06L592.61 773.1L608.26 782.14L623.94 773.1L608.29 764.06ZM635.07 810.71L619.42 819.75L635.07 828.77L650.72 819.75L635.07 810.71ZM635.16 779.58L619.5 788.64L635.16 797.68L650.82 788.64L635.16 779.58ZM635.64 842.2L619.98 851.26L635.63 860.28L651.29 851.24L635.64 842.2ZM662.08 795.12L646.42 804.16L662.07 813.2L677.73 804.16L662.08 795.12ZM662.63 826.63L646.98 835.67L662.63 844.69L678.28 835.67L662.63 826.63ZM663.2 858.11L647.54 867.17L663.19 876.19L678.85 867.15L663.2 858.11ZM689.63 811.03L673.97 820.07L689.62 829.11L705.28 820.07L689.63 811.03ZM690.18 842.54L674.53 851.58L690.18 860.6L705.84 851.58L690.18 842.54ZM717.2 826.95L701.52 835.99L717.18 845.03L732.84 835.99L717.19 826.95H717.2Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.06 694.84L364.74 685.8L380.39 694.84L364.73 703.89L349.06 694.84Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M376.08 679.25L391.73 670.23L407.37 679.25L391.73 688.29L376.08 679.25Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M376.63 710.76L392.3 701.71L407.94 710.76L392.28 719.8L376.63 710.76Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M403.06 663.68L418.73 654.64L434.37 663.66L418.71 672.72L403.06 663.68Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M403.63 695.16L419.28 686.14L434.93 695.16L419.28 704.21L403.63 695.16Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.19 726.67L419.85 717.63L435.49 726.67L419.83 735.71L404.19 726.67Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M430.62 679.59L446.28 670.55L461.94 679.57L446.26 688.61L430.62 679.59Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M431.08 742.19L446.74 733.15L462.41 742.19L446.74 751.25L431.08 742.19Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M431.19 711.08L446.83 702.05L462.5 711.08L446.83 720.12L431.19 711.08Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M457.97 757.73L473.66 748.69L569.93 804.27L554.27 813.31L457.97 757.73Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.08 726.6L473.73 717.57L489.39 726.61L473.74 735.66L458.08 726.6Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M458.17 695.5L473.85 686.46L489.5 695.48L473.83 704.53L458.17 695.5Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M484.99 742.13L500.64 733.11L516.28 742.13L500.64 751.18L484.99 742.13Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M485.06 711.02L500.73 701.98L516.41 711.02L500.73 720.06L485.06 711.02Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M511.87 757.66L527.52 748.63L543.2 757.67L527.55 766.72L511.87 757.66Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M511.98 726.56L527.64 717.52L543.29 726.54L527.62 735.59L511.98 726.56Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M538.71 773.16L554.37 764.12L570.04 773.18L554.39 782.2L538.71 773.16Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M538.85 742.08L554.53 733.04L570.2 742.08L554.53 751.12L538.85 742.08Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M565.52 819.81L581.18 810.77L596.84 819.81L581.18 828.85L565.52 819.81Z",
    fill: "#D7DCE0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M565.62 788.7L581.27 779.66L596.91 788.7L581.27 797.72L565.62 788.7Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M565.71 757.58L581.38 748.52L597.04 757.58L581.38 766.63L565.71 757.58Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M592.41 835.35L608.09 826.31L623.74 835.33L608.06 844.37L592.41 835.35Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M592.52 804.22L608.16 795.18L623.83 804.24L608.18 813.26L592.52 804.22Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M592.61 773.11L608.29 764.06L623.93 773.11L608.25 782.15L592.61 773.11Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M619.43 819.76L635.07 810.71L650.72 819.76L635.07 828.78L619.43 819.76Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M619.5 788.64L635.16 779.58L650.83 788.64L635.16 797.69L619.5 788.64Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M619.98 851.26L635.64 842.2L651.29 851.24L635.63 860.28L619.98 851.26Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M646.41 804.16L662.08 795.12L677.72 804.16L662.06 813.21L646.41 804.16Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M646.98 835.67L662.63 826.63L678.27 835.67L662.63 844.69L646.98 835.67Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M647.53 867.17L663.2 858.11L678.84 867.15L663.18 876.2L647.53 867.17Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M673.97 820.08L689.63 811.03L705.27 820.08L689.61 829.12L673.97 820.08Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M674.53 851.58L690.18 842.54L705.84 851.58L690.18 860.6L674.53 851.58Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M701.52 835.99L717.2 826.95L732.84 835.99L717.18 845.03L701.52 835.99Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M591.71 796.63C593.87 796.04 595.9 796.54 597.97 798.27C601.91 801.56 604.56 808.27 606.05 813.18C607.09 816.62 607.42 820.22 607.07 823.78L606.38 831.06C606.02 834.81 602.87 837.67 599.11 837.67C597.17 837.67 595.41 836.91 594.11 835.66L594.09 835.68C580.75 857.99 523.63 951.85 477.78 999.25C472.57 965.81 442.41 912.36 419.57 914.83L482.45 855.32C487.8 850.27 491.77 843.94 494.02 836.93L498.41 823.18C499.67 819.24 500.33 815.12 500.33 810.98V796.66C500.33 792.79 502.86 789.38 506.56 788.25C507.41 787.99 508.27 787.87 509.12 787.87C512.15 787.87 515.04 789.44 516.66 792.16L524.81 805.88L542.18 785.1C547.56 778.67 554.76 773.99 562.83 771.71L566.62 770.62C574.11 768.51 581.44 774.39 581.03 782.16L580.87 784.82C586.6 784.32 591.02 787.45 591.7 796.6L591.71 796.63Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M477.78 999.26C479.49 1010.23 478.52 1019.03 473.73 1023.01C463.33 1031.64 453.99 1041.38 443.7 1049.58C457.95 1035.86 428.25 986.32 419.57 969.84C410.89 953.34 397.97 931.35 387.99 938.29C395.9 931.53 404.06 924.62 411.7 918.29C414.17 916.23 416.82 915.14 419.57 914.85C442.4 912.38 472.57 965.83 477.78 999.27V999.26Z",
    fill: "#D7DCE0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7 1049.58L443.68 1049.6C433.01 1058.12 421.28 1064.95 406.32 1067.12C390.89 1103.71 331.36 1077.17 320.59 1071.06C315.32 1068.08 312.03 1065.87 307.22 1060.23V1060.21C305.57 1058.29 303.74 1055.95 301.61 1053.03C301.43 1052.77 301.24 1052.53 301.07 1052.29C298.14 1048.28 294.62 1043.22 290.18 1036.72C290.02 1036.91 289.86 1037.12 289.7 1037.31C278.05 1051.39 264.82 1066.3 255.85 1073.02C246.96 1079.7 225.94 1087.17 195.27 1088.78C158.93 1090.72 109.04 1084.45 49.62 1058.99C-59.98 1012 -65.74 960.09 -65.74 960.09C-65.74 960.09 -52.1699 899.93 -63.9299 879.12C-75.6899 858.31 -82.47 856.05 -82.02 809.46C-81.57 762.87 -104.19 674.63 -91.98 606.33C-80.01 539.38 -25.89 488.07 54.21 530.34C50.11 535.84 46.53 541.43 44.39 544.89C43.03 547.13 42.79 549.89 43.77 552.33C46.56 559.14 53.3 573.53 64.46 584.95C64.46 584.95 98.57 630.75 195.01 625.26C211.56 632.39 233.56 642.93 253.48 659.62C268.38 672.12 282.09 688.02 291.45 708.49C293.15 712.17 294.7 716 296.08 719.99C316.89 779.7 319.31 818.01 338.62 864.76C351.21 895.27 370.87 917.17 382.07 943.35C384.02 941.67 386 939.98 388.01 938.27C397.99 931.33 410.91 953.32 419.59 969.82C428.27 986.31 457.98 1035.85 443.72 1049.56L443.7 1049.58Z",
    fill: "#D7DCE0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M209.36 919.22C209.42 919.32 244.11 976.34 289.69 1037.32C278.04 1051.4 264.81 1066.31 255.84 1073.03C246.95 1079.71 225.93 1087.18 195.26 1088.79C197.87 1029.01 239.74 1015.15 232.3 1002.27C228.18 995.12 204.79 981.76 196.68 967.71C174.15 928.68 181.88 903.94 195.48 870.65C199.07 873.45 202.24 875.78 205 880.55C215.54 898.83 191 887.39 209.36 919.21V919.22Z",
    fill: "#D7DCE0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M395.09 634.11C398.6 634.25 401.52 634.39 403.91 634.53C408.65 634.81 412.13 639.06 411.45 643.75C410.88 647.76 407.44 650.74 403.39 650.7C390.05 650.63 361.7 650.82 353.07 653.57C341.65 657.19 344.16 666.92 353.92 669.16C358.68 670.25 364.51 673 369.23 675.54C373.9 678.05 375.32 684.09 372.19 688.39C370.24 691.07 366.95 692.42 363.66 691.85C354.68 690.33 336.35 687.72 325.52 689.76C317.65 691.25 303.21 700.33 291.44 708.49L291.42 708.51C282.06 688.03 268.34 672.13 253.45 659.64C264.3 655.35 277.25 649.86 285.4 645.22C301.56 636.02 311.02 620.43 327.18 616.8C340.22 613.89 369.77 618.05 380.68 619.76C384.57 620.37 388.31 621.82 391.46 624.22C394.71 626.69 397.46 630.19 395.09 634.11Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M294.71 320.44C296.64 340.2 280.98 357.27 261.24 357.44C252.92 347.2 236.45 341.51 228.15 362.34C221.75 378.44 219.93 421.78 219.45 440.63C219.31 445.87 218.5 451.08 216.86 456.04C216.34 457.61 215.84 459.26 215.37 460.95C204.9 460.73 177.64 460.69 166.31 466.09C137.56 454.09 113.03 488.72 141.54 515.48C136.04 523.89 126.3 535.81 115.3 535.93C98.3101 536.14 76.6901 530.69 68.2301 512.25C65.6701 501.8 61.7301 492.43 58.1801 486.08C49.7201 470.93 22.0301 424.33 34.1001 374.16C46.1701 324 99.1801 293.71 136.57 289.68C173.95 285.67 204.48 295.37 222.21 292.53C229.23 291.41 243.4 290.06 257.98 288.85C276.51 287.31 292.73 300.98 294.62 319.49C294.65 319.8 294.67 320.13 294.71 320.46V320.44Z",
    fill: "#141414"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M283.38 460.96C283.66 463.17 283.28 465.45 282.17 467.54L276.51 478.14C273.45 483.88 267.05 487.01 260.63 485.91L259.7 485.75C259.53 484.59 259.35 483.5 259.2 482.43C258.62 478.42 259.75 469.67 261.62 460.95H283.38V460.96Z",
    fill: "#D7DCE0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M283.38 460.96H261.62C262.95 454.63 264.7 448.34 266.45 443.81L279.09 453.45C281.55 455.34 283.02 458.09 283.38 460.97V460.96Z",
    fill: "#D7DCE0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M261.24 357.44C269.65 377.83 271.79 432.7 267.8 440.7C267.35 441.6 266.9 442.64 266.45 443.81C264.71 448.34 262.96 454.63 261.62 460.96C261.62 460.96 217.99 461 215.36 460.96C215.83 459.26 216.33 457.62 216.85 456.05C218.49 451.09 219.31 445.88 219.44 440.64C219.92 421.78 221.74 378.45 228.14 362.35C236.44 341.52 252.91 347.21 261.23 357.45L261.24 357.44Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M219.57 460.96H261.62C259.75 469.68 258.62 478.42 259.2 482.44C259.35 483.51 259.53 484.6 259.7 485.76C260.77 493.02 261.27 503.4 250.26 531.55C237.89 513.35 219.07 506.02 209.97 491.35C210.83 480.99 212.77 470.14 215.37 460.96C218 461.01 219.57 460.96 219.57 460.96Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M250.26 531.55C248.31 560.21 220.99 577.56 199.75 584.34C191.45 586.99 182.54 583.88 177.59 576.85C177.3 576.43 177 575.98 176.74 575.54C173.64 570.23 170.29 565.59 166.48 561.25C160.17 554.04 159.87 543.35 165.7 535.72C175.61 522.76 189.83 503.65 198.13 490.16C198.46 479.95 197.75 468.68 192.37 472.14C192.23 472.23 192.11 472.31 191.97 472.42C189.26 474.41 186.3 476.42 182.99 478.6C177.51 472.46 171.82 468.43 166.3 466.11C177.63 460.71 204.89 460.75 215.36 460.97C212.77 470.16 210.83 481 209.96 491.36C219.06 506.03 237.88 513.36 250.25 531.56L250.26 531.55Z",
    fill: "#141414"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M141.54 515.48C113.03 488.72 137.56 454.09 166.31 466.09C171.83 468.41 177.52 472.44 183 478.58C186.3 476.4 189.27 474.39 191.98 472.4C192.12 472.3 192.24 472.21 192.38 472.12C197.76 468.67 198.47 479.94 198.14 490.14C189.84 503.63 175.62 522.75 165.71 535.7C159.88 543.33 160.17 554.02 166.49 561.23C170.3 565.57 173.65 570.21 176.75 575.52C177.01 575.97 177.3 576.42 177.6 576.83C170.65 582.47 167.52 591.07 166.1 597.85C126.68 593.28 89.33 559.71 70.67 539.83C71.17 534.85 71.05 529.73 70.48 524.68C70.01 520.44 69.23 516.26 68.25 512.23C76.71 530.67 98.33 536.12 115.32 535.91C126.32 535.79 136.06 523.87 141.56 515.46L141.54 515.48Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.08 597.87C173.09 598.7 180.16 598.6 187.22 597.33C187.22 597.33 191.67 605.05 194.99 625.27C98.5503 630.77 64.4403 584.96 64.4403 584.96C53.2803 573.53 46.5303 559.15 43.7503 552.34C42.7603 549.9 43.0103 547.15 44.3703 544.9C46.5203 541.44 50.0903 535.85 54.1903 530.35C55.4903 528.6 56.8403 526.86 58.2203 525.19C58.2203 525.52 62.7703 531.47 70.6403 539.84C89.3003 559.72 126.65 593.29 166.07 597.86L166.08 597.87Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M70.46 524.7C71.03 529.75 71.15 534.87 70.65 539.85C62.78 531.48 58.23 525.53 58.23 525.2C58.82 523.75 64.72 524.04 70.46 524.7Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7 1049.58C453.99 1041.38 463.34 1031.64 473.73 1023.01C478.52 1019.03 479.49 1010.23 477.78 999.26C472.57 965.82 442.41 912.39 419.57 914.84C416.82 915.14 414.17 916.22 411.7 918.28C404.05 924.61 384 941.68 382.05 943.36",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M202.96 907.52C232 957.37 259.27 991.09 283.29 1026.58C285.82 1030.3 288.1 1033.67 290.17 1036.72C307.93 1062.74 310.94 1065.61 320.58 1071.06C331.34 1077.17 390.88 1103.7 406.31 1067.12C421.27 1064.94 433 1058.11 443.67 1049.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M419.57 914.84L482.45 855.33C487.8 850.28 491.77 843.95 494.02 836.94L498.41 823.19C499.67 819.25 500.33 815.13 500.33 810.99V796.67C500.33 792.8 502.86 789.39 506.56 788.26C507.41 788 508.27 787.88 509.12 787.88C512.15 787.88 515.04 789.45 516.66 792.17L524.81 805.89L542.18 785.11C547.56 778.68 554.76 774 562.83 771.72L566.62 770.63C574.11 768.52 581.44 774.4 581.03 782.17L580.87 784.83",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M557.42 799.72C563.96 792.14 573.51 785.49 580.88 784.84C586.61 784.34 591.03 787.47 591.71 796.62",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M573.15 814.98C581.5 804.5 586.95 797.92 591.71 796.63C593.87 796.04 595.9 796.54 597.97 798.27C601.91 801.56 604.56 808.27 606.05 813.18C607.09 816.62 607.42 820.22 607.07 823.78L606.38 831.06C606.02 834.81 602.87 837.67 599.11 837.67C597.17 837.67 595.41 836.91 594.11 835.66C594.06 835.63 594.01 835.57 593.95 835.52C592.62 834.2 591.8 832.39 591.8 830.37V824.38",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M477.78 999.26C523.64 951.86 580.76 858 594.09 835.69",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M357.23 987.51C365.91 972.2 366.83 942.48 362.04 926.95",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M202.03 901.57C221.47 878.6 183.3 868.89 187.41 855.64",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M216.21 865.7C224.43 848.56 233.35 797.13 233.35 797.13",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M211.4 908.22C229.68 909.36 239.06 901.58 239.06 901.58",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.5898 555.04C-12.3498 543.28 10.6002 543.52 24.7502 546.72",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.6001 575.47C3.1199 572.04 14.9399 563.91 14.9399 563.91",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M191.98 472.4C189.25 474.35 186.31 476.4 183 478.58C177.52 472.44 171.83 468.4 166.31 466.09C137.57 454.05 113.04 488.7 141.54 515.48C146.78 520.41 153.82 525.08 162.97 529.13",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M148.27 478.68C152.73 477 159.38 477.44 164.84 480.69C168.41 482.81 171.48 486.16 173.04 490.95",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 491.78C156.98 485.6 164.37 480.97 164.84 480.69L164.86 480.67",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M261.24 357.44C252.92 347.2 236.45 341.51 228.15 362.34C221.75 378.44 219.93 421.78 219.45 440.63C219.31 445.87 218.5 451.08 216.86 456.04C216.34 457.61 215.84 459.26 215.37 460.95C212.81 470.14 210.84 480.98 209.97 491.34C219.07 506.01 237.89 513.34 250.26 531.54",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1899 512.17C68.1899 512.17 68.2099 512.22 68.2199 512.24C76.6799 530.68 98.2999 536.13 115.29 535.92C126.29 535.8 136.03 523.88 141.53 515.47",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M166.31 466.09C177.64 460.69 204.9 460.74 215.37 460.95C218 461 219.57 460.95 219.57 460.95H283.4",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M266.45 443.81L279.09 453.45C281.55 455.34 283.02 458.09 283.38 460.97C283.66 463.18 283.28 465.46 282.17 467.55L276.51 478.15C273.45 483.89 267.05 487.02 260.63 485.92L259.7 485.76",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M358.65 633.5C374.74 633.5 386.62 633.77 395.1 634.11C398.61 634.25 401.53 634.39 403.92 634.53C408.66 634.81 412.14 639.06 411.46 643.75C410.89 647.76 407.45 650.74 403.4 650.7C390.06 650.63 361.71 650.82 353.08 653.57C341.66 657.19 344.17 666.92 353.93 669.16C358.69 670.25 364.52 673 369.24 675.54C373.91 678.05 375.33 684.09 372.2 688.39C370.25 691.07 366.96 692.42 363.67 691.85C354.69 690.33 336.36 687.72 325.53 689.76C317.66 691.25 303.22 700.33 291.45 708.49",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M177.59 576.85C170.64 582.49 167.51 591.09 166.09 597.87V597.89",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 872.69C96.89 898.46 122.99 904.16 147.07 950.65",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M191.98 472.4C192.12 472.3 192.24 472.21 192.38 472.12C197.76 468.67 198.47 479.94 198.14 490.14C189.84 503.63 175.62 522.75 165.71 535.7C159.88 543.33 160.17 554.02 166.49 561.23C170.3 565.57 173.65 570.21 176.75 575.52C177.01 575.97 177.3 576.42 177.6 576.83C182.55 583.86 191.46 586.97 199.76 584.32C221 577.54 248.32 560.19 250.27 531.53C261.29 503.39 260.78 493 259.71 485.74C259.54 484.58 259.36 483.49 259.21 482.42C258.63 478.41 259.78 469.67 261.63 460.94C262.97 454.61 264.72 448.32 266.46 443.79C266.91 442.61 267.36 441.58 267.81 440.68C271.81 432.69 269.66 377.82 261.25 357.42C280.99 357.25 296.65 340.18 294.72 320.42C294.69 320.09 294.67 319.76 294.63 319.45C292.75 300.94 276.52 287.28 257.99 288.81C243.41 290.02 229.24 291.37 222.22 292.49C204.49 295.33 173.96 285.62 136.58 289.64C99.1803 293.67 46.1803 323.96 34.1103 374.12C22.0403 424.28 49.7304 470.89 58.1904 486.04C61.7404 492.39 65.6803 501.76 68.2403 512.21C69.2303 516.24 70.0004 520.43 70.4704 524.66C71.0304 529.71 71.1604 534.83 70.6604 539.81",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M966.49 367.92V695.86C966.49 701.8 964.54 706.01 961.42 707.84L940.46 720.41V720.39C943.58 718.57 945.51 714.37 945.51 708.43V380.51C945.51 369.54 938.88 356.81 930.65 352.07L552.28 133.61C548.65 131.52 545.33 131.32 542.75 132.72L563.44 120.29C566.05 118.75 569.48 118.87 573.25 121.04L951.62 339.5C959.83 344.24 966.5 356.97 966.5 367.92H966.49Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M945.51 668.79V708.44C945.51 714.38 943.58 718.59 940.46 720.4C937.83 721.98 934.4 721.84 930.65 719.67L552.97 501.65C543.34 496.08 537.4 485.78 537.4 474.63V144.87C537.4 138.73 539.47 134.49 542.75 132.73C545.34 131.33 548.65 131.53 552.28 133.62L930.65 352.08C938.88 356.82 945.51 369.55 945.51 380.52V668.79ZM925.54 689.77V380.64C925.54 375.88 922.54 369.96 919.11 367.99L559.88 160.59C559.13 160.16 558.68 160.1 558.52 160.1C558.07 160.1 557.39 161.32 557.39 163.53V472.66C557.39 477.44 560.39 483.36 563.82 485.33L923.05 692.73C923.8 693.16 924.25 693.22 924.41 693.22C924.86 693.22 925.53 692 925.53 689.77H925.54Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M925.54 423.19V689.77C925.54 692 924.87 693.22 924.42 693.22C924.26 693.22 923.81 693.16 923.06 692.73L563.83 485.33C560.4 483.36 557.4 477.43 557.4 472.66V210.63L925.55 423.19H925.54Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M925.54 380.63V423.18L557.39 210.62V163.51C557.39 161.3 558.06 160.08 558.52 160.08C558.68 160.08 559.13 160.14 559.88 160.57L919.11 367.97C922.54 369.94 925.54 375.86 925.54 380.62V380.63ZM628.36 227.39C628.36 223.6 625.7 219 622.42 217.11C619.14 215.22 616.5 216.75 616.5 220.54C616.5 224.33 619.14 228.91 622.42 230.8C625.7 232.69 628.36 231.16 628.36 227.39ZM608.25 215.76C608.25 211.97 605.59 207.37 602.31 205.5C599.03 203.61 596.37 205.13 596.37 208.91C596.37 212.69 599.03 217.3 602.31 219.19C605.59 221.08 608.25 219.55 608.25 215.76ZM588.12 204.16C588.12 200.37 585.48 195.77 582.2 193.88C578.92 191.99 576.26 193.52 576.26 197.31C576.26 201.1 578.92 205.68 582.2 207.57C585.48 209.46 588.12 207.93 588.12 204.16Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M845.81 670.72L861.38 679.72C857.53 690.99 847.5 705.12 828.81 715.86C807.85 727.96 780.41 734.02 752.94 734.02C725.47 734.02 698.05 727.96 677.09 715.86C635.21 691.68 635.21 652.46 677.09 628.26C682.85 624.96 689.09 622.08 695.66 619.71V648.37C695.66 651.8 697.93 655.24 702.45 657.84L765 693.96C774.06 699.19 788.76 699.19 797.82 693.96C802.38 691.33 804.63 687.88 804.61 684.43V646.93L845.8 670.71L845.81 670.72Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M804.62 684.44C804.64 687.89 802.39 691.35 797.83 693.97C788.77 699.2 774.07 699.2 765.01 693.97L702.46 657.85C697.94 655.24 695.67 651.81 695.67 648.38V584.03L804.62 646.93V684.43V684.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M622.42 217.11C625.7 219 628.36 223.6 628.36 227.39C628.36 231.18 625.7 232.7 622.42 230.8C619.14 228.91 616.5 224.31 616.5 220.54C616.5 216.77 619.14 215.21 622.42 217.11Z",
    fill: "#459AA4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M602.31 205.5C605.59 207.38 608.25 211.97 608.25 215.76C608.25 219.55 605.59 221.09 602.31 219.19C599.03 217.3 596.37 212.7 596.37 208.91C596.37 205.12 599.03 203.6 602.31 205.5Z",
    fill: "#459AA4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M582.2 193.88C585.48 195.77 588.12 200.37 588.12 204.16C588.12 207.95 585.48 209.47 582.2 207.57C578.92 205.68 576.26 201.08 576.26 197.31C576.26 193.54 578.92 191.98 582.2 193.88Z",
    fill: "#459AA4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M925.54 423.19V689.77C925.54 692 924.87 693.22 924.42 693.22C924.26 693.22 923.81 693.16 923.06 692.73L563.83 485.33C560.4 483.36 557.4 477.43 557.4 472.66V163.52C557.4 161.31 558.07 160.09 558.53 160.09C558.69 160.09 559.14 160.15 559.89 160.58L919.12 367.98C922.55 369.95 925.55 375.87 925.55 380.63V423.18L925.54 423.19Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M557.39 210.63L925.54 423.19",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M588.12 204.16C588.12 207.93 585.48 209.47 582.2 207.57C578.92 205.68 576.26 201.08 576.26 197.31C576.26 193.54 578.92 191.98 582.2 193.88C585.48 195.78 588.12 200.37 588.12 204.16Z",
    stroke: "#DAE0E5",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M608.25 215.76C608.25 219.55 605.59 221.09 602.31 219.19C599.03 217.3 596.37 212.7 596.37 208.91C596.37 205.12 599.03 203.6 602.31 205.5C605.59 207.38 608.25 211.97 608.25 215.76Z",
    stroke: "#DAE0E5",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M628.36 227.39C628.36 231.16 625.7 232.7 622.42 230.8C619.14 228.91 616.5 224.31 616.5 220.54C616.5 216.77 619.14 215.21 622.42 217.11C625.7 219 628.36 223.6 628.36 227.39Z",
    stroke: "#DAE0E5",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_885_1063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 643,
    y: 378,
    width: 161,
    height: 137
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M643.58 422.17L643.7 378.34L803.68 470.7L803.55 514.53L643.58 422.17Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_885_1063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_885_1063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 643,
    y: 378,
    width: 161,
    height: 137
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M643.7 378.34L803.68 470.7L803.55 514.53L643.58 422.17L643.7 378.34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_885_1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.51 424.47L702.21 422.56L702.19 430.71C702.19 431.76 702.19 432.77 702.21 433.74C702.23 434.73 702.25 435.67 702.28 436.57C702.31 437.48 702.35 438.34 702.39 439.16C702.43 439.98 702.49 440.76 702.55 441.49C702.57 441.71 702.59 441.93 702.61 442.14L690.23 415.64L687.27 413.93L687.2 438.74L690.5 440.65L690.53 430.33C690.53 430.12 690.53 429.86 690.52 429.58C690.51 429.29 690.5 428.92 690.47 428.47C690.45 428.02 690.42 427.44 690.37 426.71C690.32 425.98 690.26 425.09 690.19 424.05C690.14 423.29 690.08 422.4 690.02 421.4L702.42 447.54L705.45 449.29L705.52 424.47",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.25 455.89H716.26H716.25ZM713.84 435.49L710.69 433.67L710.66 445.16C710.66 446.69 710.88 448.15 711.33 449.52C711.79 450.9 712.44 452.15 713.28 453.24C714.12 454.34 715.11 455.22 716.25 455.88C717.17 456.41 718.01 456.69 718.81 456.74C719.61 456.79 720.3 456.63 720.88 456.25C721.14 456.08 721.37 455.87 721.57 455.63V458.59L724.71 460.41L724.76 441.8L721.61 439.98L721.58 451.18C721.58 451.84 721.47 452.4 721.27 452.85C721.06 453.3 720.78 453.62 720.42 453.82C720.06 454.01 719.64 454.08 719.15 454.03C718.66 453.97 718.12 453.77 717.53 453.43C716.73 452.97 716.06 452.37 715.5 451.62C714.94 450.87 714.51 450.01 714.22 449.05C713.93 448.09 713.78 447.06 713.79 445.98L713.82 435.48",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.04 464.55C736.08 463.99 735.23 463.23 734.5 462.25C733.77 461.26 733.19 460.17 732.77 458.97C732.35 457.77 732.13 456.52 732.13 455.32C732.13 454.12 732.35 453.16 732.78 452.45C733.21 451.74 733.79 451.32 734.52 451.19C735.26 451.07 736.11 451.29 737.06 451.84C738.02 452.39 738.87 453.15 739.59 454.12C740.33 455.1 740.9 456.18 741.31 457.38C741.72 458.57 741.93 459.75 741.93 460.98C741.93 462.21 741.71 463.18 741.28 463.89C740.85 464.6 740.27 465.02 739.53 465.16C738.8 465.29 737.96 465.08 737.02 464.54M732.35 438.55L729.2 436.73L729.13 462.87L732.28 464.69V462.32C732.65 463.04 733.1 463.77 733.64 464.5C734.2 465.26 734.82 465.97 735.5 466.63C736.19 467.28 736.87 467.81 737.57 468.21C738.97 469.02 740.24 469.33 741.36 469.13C742.48 468.94 743.37 468.29 744.01 467.2C744.66 466.11 744.98 464.62 744.99 462.76C744.99 460.9 744.67 459.04 744.03 457.21C743.38 455.38 742.5 453.72 741.38 452.25C740.27 450.78 738.98 449.63 737.53 448.79C736.88 448.41 736.23 448.16 735.6 448.04C734.97 447.92 734.38 447.92 733.84 448.02C733.3 448.12 732.85 448.33 732.51 448.64C732.44 448.7 732.38 448.76 732.32 448.83L732.35 438.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.72 464.06C750.82 463.58 750.96 463.17 751.14 462.84C751.53 462.13 752.1 461.74 752.86 461.69C753.61 461.64 754.54 461.93 755.64 462.57C756.34 462.97 756.98 463.53 757.57 464.22C758.16 464.92 758.65 465.68 759.03 466.52C759.41 467.36 759.63 468.18 759.69 469V469.25L750.71 464.07M755.65 459.21C754.48 458.53 753.37 458.14 752.37 458.04C751.35 457.95 750.49 458.13 749.77 458.6C749.04 459.06 748.47 459.78 748.06 460.75C747.65 461.72 747.44 462.94 747.44 464.41C747.44 466.25 747.79 468.09 748.51 469.92C749.23 471.76 750.23 473.45 751.5 475C752.77 476.55 754.23 477.8 755.88 478.76C756.63 479.19 757.41 479.52 758.19 479.72C758.98 479.93 759.72 480.02 760.43 480C761.13 479.99 761.74 479.83 762.22 479.55L760.64 476.05C759.84 476.39 759.1 476.52 758.41 476.43C757.73 476.34 756.99 476.07 756.19 475.61C755.07 474.96 754.08 474.13 753.23 473.12C752.37 472.09 751.71 470.98 751.24 469.75C750.89 468.82 750.67 467.87 750.59 466.9L762.86 473.99L762.89 472.45C762.92 471.17 762.75 469.86 762.4 468.56C762.05 467.25 761.54 466.01 760.88 464.83C760.21 463.64 759.43 462.56 758.54 461.58C757.65 460.6 756.68 459.81 755.64 459.21",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.57 472.87L775.42 471.05L775.37 489.66L778.52 491.48L778.57 472.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.97 463.22C776.32 462.84 775.8 462.76 775.42 462.97C775.04 463.18 774.86 463.62 774.85 464.31C774.85 465.04 775.03 465.72 775.39 466.32C775.75 466.93 776.28 467.43 776.95 467.82C777.62 468.21 778.11 468.28 778.49 468.07C778.87 467.87 779.06 467.42 779.06 466.74C779.06 466.01 778.88 465.33 778.51 464.72C778.15 464.11 777.61 463.6 776.96 463.22",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.1 496.53C792.06 495.93 791.11 495.16 790.24 494.2C789.37 493.25 788.62 492.19 787.99 491.02C787.35 489.84 786.86 488.6 786.52 487.29C786.18 485.98 786.01 484.7 786.01 483.37C786.01 482.05 786.19 480.93 786.54 480.04C786.89 479.13 787.38 478.47 788.03 478.03C788.68 477.6 789.43 477.41 790.3 477.46C791.17 477.51 792.12 477.84 793.16 478.44C794.2 479.04 795.15 479.81 796.02 480.76C796.89 481.72 797.63 482.78 798.26 483.96C798.88 485.14 799.38 486.38 799.73 487.68C800.08 488.99 800.26 490.29 800.26 491.59C800.26 492.89 800.07 493.99 799.71 494.88C799.36 495.78 798.86 496.44 798.23 496.9C797.59 497.35 796.84 497.55 795.98 497.5C795.11 497.45 794.15 497.12 793.12 496.52M793.16 474.72C791.65 473.85 790.26 473.37 788.99 473.27C787.71 473.16 786.6 473.42 785.65 474.02C784.7 474.62 783.96 475.54 783.44 476.79C782.92 478.03 782.65 479.58 782.65 481.42C782.65 483.26 782.9 485.11 783.41 486.95C783.93 488.8 784.66 490.57 785.6 492.26C786.54 493.96 787.65 495.49 788.93 496.86C790.2 498.23 791.59 499.36 793.1 500.23C794.61 501.1 796 501.58 797.27 501.68C798.54 501.78 799.66 501.52 800.61 500.91C801.56 500.3 802.3 499.36 802.82 498.12C803.34 496.88 803.61 495.34 803.61 493.52C803.61 491.7 803.36 489.86 802.85 488.02C802.33 486.17 801.6 484.39 800.66 482.68C799.72 480.98 798.6 479.43 797.33 478.06C796.06 476.69 794.67 475.56 793.16 474.69",
    fill: "#459AA4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionaldark);
export default __webpack_public_path__ + "static/media/Professionaldark.04c484d84a96ffc063d960aa3e75f99b.svg";
export { ForwardRef as ReactComponent };